import { call, put, takeEvery, takeLatest, select } from "redux-saga/effects"
import firebase from "../../firebase"
import root from "window-or-global"

function* validate(action) {
  try {
    console.log("validate saga called")

    if (firebase.auth().isSignInWithEmailLink(root.location.href)) {
      const email =
        root.localStorage.getItem("emailForSignIn") || prompt("email?")
      if (email) {
        // setValidating(true)
        firebase
          .auth()
          .signInWithEmailLink(email, root.location.href)
          .then(function(result) {
            // Success! Clear email from storage.
            root.localStorage.removeItem("emailForSignIn")
            // root.location.assign("/dashboard")
            root.history.replaceState({}, document.title, "/")
            // setValidating(false)
          })
          .catch(function(error) {
            console.log("login error:", error)
            // setValidating(false)
          })
      } else  {
        console.log('NO EMAIL FOR VALIDATION SAGA');
      }
    } else {
      yield put({ type: "SET_USER", payload: { authenticated: false } })
      yield put({ type: "SET_LOADING", payload: false })
    }
  } catch (error) {}
}

export default validate
